import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { getDashboardCountsRequest } from "api/api";

function Dashboard() {
  // ✅ State for live calls
  const [liveCallsCount, setLiveCallsCount] = useState(0);

  const [dashboardCounts, setDashboardCounts] = useState({
    campaigns: 0,
    trunks: 0,
    dtmf_count: 0,
  });
  const [cdrReportChart, setCdrReportChart] = useState({ labels: [], datasets: [] });
  const [callStatsChart, setCallStatsChart] = useState({ labels: [], datasets: [] });
  const [trunkStatsChart, setTrunkStatsChart] = useState({ labels: [], datasets: [] });
  const [totals, setTotals] = useState({ answered: 0, dropped: 0, not_answered: 0, dialed: 0 });

  // ✅ Callback function jo navbar se data receive karega
  const handleLiveCallsUpdate = (callsData) => {
    setLiveCallsCount(callsData?.all_calls || 0);
  };

  useEffect(() => {
    getDashboardCountsRequest()
      .then((res) => {
        const data = res?.data?.data || {};

        // Top Cards
        setDashboardCounts({
          campaigns: data.total_campaign || 0,
          trunks: data.total_trunk || 0,
          dtmf_count: data.dtmf_pressed || 0,
        });

        // Totals
        setTotals({
          answered: data.answered || 0,
          dropped: data.dropped || 0,
          not_answered: data.un_answered || 0,
          dialed: data.dialed || 0,
        });
      })
      .catch((err) => {
        console.error("Failed to fetch dashboard data", err);
      });
  }, []);

  // useEffect(() => {
  //   getDashboardGraphsRequest()
  //     .then((res) => {
  //       const dailyData = res.data?.data?.daily || [];
  //       const totalStats = res.data?.data?.totals || {};

  //       setTotals(totalStats);

  //       const labels = dailyData.map((item) => item.date);
  //       const answered = dailyData.map((item) => item.answered);
  //       const notAnswered = dailyData.map((item) => item.not_answered);
  //       const dropped = dailyData.map((item) => item.dropped);
  //       const dialed = dailyData.map((item) => item.dialed);

  //       setCdrReportChart({
  //         labels,
  //         datasets: {
  //           label: "Answered",
  //           color: "info",
  //           data: answered,
  //         },
  //       });

  //       setCallStatsChart({
  //         labels,
  //         datasets: {
  //           label: "Dropped",
  //           data: dropped,
  //         },
  //       });

  //       setTrunkStatsChart({
  //         labels,
  //         datasets: {
  //           label: "Dialed",
  //           data: dialed,
  //         },
  //       });
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching chart data", err);
  //     });
  // }, []);

  return (
    <DashboardLayout>
      {/* ✅ Pass callback function as prop */}
      <DashboardNavbar onLiveCallsUpdate={handleLiveCallsUpdate} />

      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="weekend"
                title="Campaigns"
                count={dashboardCounts.campaigns}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                title="Live Calls"
                count={liveCallsCount} // ✅ Use state here
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="store"
                title="Trunks"
                count={dashboardCounts.trunks}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="dialpad"
                title="DTMF Pressed"
                count={dashboardCounts.dtmf_count}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Just updated",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>

        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4} sx={{ height: "400px" }}>
              <MDBox mb={3} sx={{ height: "100%" }}>
                <ReportsBarChart
                  color="info"
                  title={<>Answered and UnAnswered</>}
                  description={
                    <Grid container spacing={2}>
                      <Grid item xs={6} sx={{ mt: 2 }}>
                        <MDTypography variant="button" color="text">
                          Answered:
                        </MDTypography>
                      </Grid>
                      <Grid item xs={6} sx={{ mt: 2 }}>
                        <MDTypography
                          variant="button"
                          fontWeight="medium"
                          textAlign="right"
                          display="block"
                        >
                          {totals.answered}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={6}>
                        <MDTypography variant="button" color="text">
                          Not Answered:
                        </MDTypography>
                      </Grid>
                      <Grid item xs={6}>
                        <MDTypography
                          variant="button"
                          fontWeight="medium"
                          textAlign="right"
                          display="block"
                        >
                          {totals.not_answered}
                        </MDTypography>
                      </Grid>
                    </Grid>
                  }
                  date="Just updated"
                  chart={cdrReportChart}
                />
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={4} sx={{ height: "400px" }}>
              <MDBox mb={3} sx={{ height: "100%" }}>
                <ReportsLineChart
                  color="success"
                  title="Dropped"
                  description={
                    <Grid container spacing={2}>
                      <Grid item xs={6} sx={{ mt: 2 }}>
                        <MDTypography variant="button" color="text">
                          Dropped:
                        </MDTypography>
                      </Grid>
                      <Grid item xs={6} sx={{ mt: 2, mb: 5 }}>
                        <MDTypography
                          variant="button"
                          fontWeight="medium"
                          textAlign="right"
                          display="block"
                        >
                          {totals.dropped}
                        </MDTypography>
                      </Grid>
                    </Grid>
                  }
                  date="Just Updated"
                  chart={callStatsChart}
                />
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6} lg={4} sx={{ height: "400px" }}>
              <MDBox mb={3} sx={{ height: "100%" }}>
                <ReportsLineChart
                  color="dark"
                  title="Dialed"
                  description={
                    <Grid container spacing={2}>
                      <Grid item xs={6} sx={{ mt: 2 }}>
                        <MDTypography variant="button" color="text">
                          Dialed:
                        </MDTypography>
                      </Grid>
                      <Grid item xs={6} sx={{ mt: 2, mb: 5 }}>
                        <MDTypography
                          variant="button"
                          fontWeight="medium"
                          textAlign="right"
                          display="block"
                        >
                          {totals.dialed}
                        </MDTypography>
                      </Grid>
                    </Grid>
                  }
                  date="Just updated"
                  chart={trunkStatsChart}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
